module.exports = __webpack_public_path__ + "static/media/55.6a921a11.png";